<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <h2 class="title">Dev Tools</h2>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="secondary"
      ngbTooltip="Copy Auth Token"
      icon="content-copy"
      (click)="copyAuthToken()"
      class="filter-button"
      placement="bottom-right"
    >
      Copy Auth Token
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="danger"
      ngbTooltip="Clear Tables"
      icon="delete"
      (click)="clearData()"
      class="filter-button"
      placement="bottom-right"
    >
      Clear Tables
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="primary"
      [ngbTooltip]="isPlaying ? 'Pause' : 'Play'"
      [icon]="isPlaying ? 'pause' : 'play'"
      (click)="toggleStream()"
      class="filter-button"
      placement="bottom-right"
    >
      {{ isPlaying ? 'Pause' : 'Play' }} SSEs
    </button>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <nf-table-layout
      class="devtools-table-layout"
      [hideTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [autoResizeGrid]="false"
      [data]="_data"
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
